import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import createLogger from 'redux-logger'

import { initialState, reducer } from 'state/reducers'

const loggerMiddleware = createLogger({
  collapsed: true,
  timestamp: false,
  duration: true
})



const store = createStore(
  reducer,
  initialState,
  compose(
    applyMiddleware(
    thunkMiddleware,
    loggerMiddleware
  ),
  window.devToolsExtension ? window.devToolsExtension() : f => f
  ))

export default store






// WEBPACK FOOTER //
// ./state/index.js